<template>
<div id="dashboard">
  <div v-if="!states.viewAllow && !states.showFail" class="loader overlay">
    <img class="overlay-container" src="@/assets/img/loader.gif" />
  </div>
  <div  v-if="states.showFail">
    <p></p><p class="text-center" v-if="tplData.general"><label v-html="tpl('general.errorLoading')"></label></p>
  </div>
  <div v-if="states.viewAllow">

      <div class="row">
        <div class="large-12 medium-12 small-12 columns"><p></p>
          <h2>PROFIL</h2><hr>
          <h2>{{ custName }}</h2>
          <div class="press">
              <p>{{  (productdetail.profile.streetName || '') + ' ' + (productdetail.profile.streetNumber || '') }}<br/>
                  {{ (productdetail.profile.zipCode || '') + ' ' + (productdetail.profile.city || '') }}</p>
              <hr>
          </div>
          <span class="left">Tel. číslo</span>
          <span class="right"><big>{{ readMsisdn }}</big></span>
          <hr />
          <span class="left">Program</span>
          <span class="right"><big>{{ readRpln }}</big></span>
          <hr>
        </div>        
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'profil',
  data () {
    return {
      msg: 'Profil',
      tplData: {},
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      states: {
        viewAllow: false, showWait: true, showFail: false
      },
      msisdn: '',
      productdetail: {}
    }
  },
  mounted:  function() {
  },
  computed: {
    readMsisdn: function() {
      return '0' + String(this.msisdn).substring(3)
    },
    readRpln: function() {
      var res = this.productdetail.product.productName
      if (res.toLowerCase().indexOf('easy') !== -1) {
      return res.substring(res.toLowerCase().indexOf('easy'))
      } else {
        if (res.toLowerCase().indexOf('t karta') !== -1) {
          res = "Predplatenka"
          var productNumber = this.productdetail.product.productNumber;
          if (productNumber && productNumber === 'PR1920') {
            res = "Digitálny senior";
          } 
        }
        else if (res.toLowerCase().indexOf('ares') !== -1) {
          res = "Juro"
        } else if ((res || '').toLowerCase().indexOf('young') !== -1) {
          res = "SWIPE"
        } else {
          var tr = res.split('-')
          if (tr[1]) {
            tr.shift()
            res = tr.join('-')
          }
        }
        return res
      }
    },
    custName: function() {
      var res = ''
      if (!_.isEmpty(this.productdetail.profile.name)) {
        res = this.productdetail.profile.name.replace(/,/, ' ').replace(/,/g, ', ')
      } else {
        res = "neznámy"
      }
      return res
    }
  },
  created: function() {
    var that = this

    if (document.getElementById("msisdnTextSpan") === null) {
      var msisdnTextSpan = document.createElement("span")
      msisdnTextSpan.id = "msisdnTextSpan"
      var msisdnTemp = document.getElementById("jsHolder")
      msisdnTemp.appendChild(msisdnTextSpan)
    }  else {
      var msisdnTextSpan = document.getElementById("msisdnTextSpan")
    }

    var productDetailAllow = false, tplDataAllow = false;

    if (_.isEmpty(this.$store.state.productdetail)) {
      that.$store.dispatch('refreshProductDetail').then(() => {
       if (that.$store.state.httpCodes.productdetail === 200) {
          that.productdetail = that.$store.state.productdetail
          that.msisdn = that.$store.state.productdetail.msisdn
          msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
       }        
       
       if (that.$store.state.httpCodes.productdetail === 403) {
          window.location.href = '/prihlasenie/?url=' + encodeURIComponent(that.$router.history.base + that.$route.fullPath)
       } else if (that.$store.state.httpCodes.productdetail === 400) {
          window.location.href = '/spotreba/profil'
       } else if (_.isEmpty(that.productdetail)) {
            that.states.showFail = true
       } else {
            productDetailAllow = true
            if (tplDataAllow) {
              that.states.viewAllow = true
            }
          }
      })
    } else {
        that.productdetail = that.$store.state.productdetail
        that.msisdn = that.$store.state.productdetail.msisdn
        msisdnTextSpan.innerHTML = '0' + that.msisdn.toString().substring(3)
        that.states.viewAllow = true
    }
    if (_.isEmpty(this.$store.state.tplData)) {
      that.$store.dispatch('refreshTplData').then(() => {
        that.tplData = that.$store.state.tplData
        tplDataAllow = true
        if (productDetailAllow) {
          that.states.viewAllow = true
        }
      });
    } else {
        that.tplData = that.$store.state.tplData
        that.states.viewAllow = true
    }
  }, methods: {

  }
}
</script>

<style scoped>

big {
  font-size: 1.4rem;
}

</style>
